import { render, staticRenderFns } from "./phoneExtForm.vue?vue&type=template&id=0f5bceba&%23default=true&"
import script from "./phoneExtForm.vue?vue&type=script&lang=js&"
export * from "./phoneExtForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports